import { render, staticRenderFns } from "./creativeItem.vue?vue&type=template&id=1c9c89cd"
import script from "./creativeItem.vue?vue&type=script&lang=js"
export * from "./creativeItem.vue?vue&type=script&lang=js"
import style0 from "./creativeItem.vue?vue&type=style&index=0&id=1c9c89cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports